module.exports = __webpack_public_path__ + "static/media/baristas.7f0fe904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/baristas.jpg
// module id = 92
// module chunks = 0